module.exports = __webpack_public_path__ + "static/media/52765579_2452978711443972_752778149170774016_o.d314195f.jpg";